export const mapTalents = info => {
  const talents = info?.map(talent => ({
    first_name: talent?.first_name,
    last_name: talent?.last_name,
    name: `${talent?.first_name} ${talent?.last_name}`,
    id: talent?.id,
    image: talent?.image,
    type: talent?.search_roles?.map(role => role?.NOMBRE).join(', ').toUpperCase(),
    internalId: talent?.internal_ids?.[0] || talent?.id,
  }));

  return talents;
};
